"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkForCTAClassName = void 0;
const checkForCTAClassName = (ctas, themes) => {
  if (!ctas || !themes) {
    return;
  }
  if (ctas?.ctaOne && !ctas?.ctaOne?.className) {
    ctas.ctaOne.className = themes?.ctaOne;
  }
  if (ctas?.ctaTwo && !ctas?.ctaTwo?.className) {
    ctas.ctaTwo.className = themes?.ctaTwo;
  }
  return ctas;
};
exports.checkForCTAClassName = checkForCTAClassName;